import type {
  PropertyHeroData,
  GalleryImage,
  PropertyStoryData,
  SignatureFeature,
  EssentialInfoGroup,
  PropertyReview,
  PropertyConciergeConfig,
  PropertyInquiryData,
  StickyBookBarData,
} from '../types';

export const heroData: PropertyHeroData = {
  id: 'sunset-bungalow-30a',
  name: 'Sunset Bungalow on 30A',
  location: 'Dune Allen',
  area: '30A',
  bedrooms: '4',
  bathrooms: '2',
  sleeps: 'Up to 10',
  heroImage: 'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-1.jpg',
};

const orderedGalleryUrls = [
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-1.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-2.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-3.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-4.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-5.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-6.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-7.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-8.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-9.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-10.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-11.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-12.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-13.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-14.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-15.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-16.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-17.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-18.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-19.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-20.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-21.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-22.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-23.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-24.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-25.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-26.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-27.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-28.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-29.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-30.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-31.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-32.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-33.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-34.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-35.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-36.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-37.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-38.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-39.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-40.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-41.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-42.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-43.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-44.jpg',
  'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-45.jpg',
];

export const galleryImages: GalleryImage[] = orderedGalleryUrls.map((src, index) => ({
  src,
  alt: `Sunset Bungalow on 30A photo ${index + 1}`,
  caption: `Photo ${index + 1} of ${orderedGalleryUrls.length}`,
}));

export const storyData: PropertyStoryData = {
  subheading: 'A lake out front, the Gulf out back, and the best of 30A all around you.',
  paragraphs: [
    'Sunset Bungalow on 30A is a 4-bedroom, 2-bath coastal cottage in Dune Allen with fabulous views of the Gulf of Mexico and beach access just steps from the backyard.',
    'The open floor plan is oriented toward the Gulf views. The living area includes a 65-inch flat-screen TV and a queen sofa sleeper, creating an easy place to relax after the beach.',
    'The kitchen is set up for real family meals, with top-of-the-line appliances, equipment and utensils in place, and a dining area with seating for eight.',
    'The primary suite has a king bed, a 55-inch flat-screen television, views toward the outdoor living space and Gulf, sliding-door access outside, and an en suite bathroom with walk-in shower and double vanity.',
    'The outdoor living area is a major part of the home: beach views, lounge chairs, easy access to the sand, a front porch overlooking Allen Lake, a gas grill, and four bikes for exploring 30A.',
  ],
  locationContext:
    'Sunset Bungalow is in the heart of Dune Allen, across the street from Stinky’s Fish Camp and about 1.5 miles from Shunk Gulley, Perfect Pig, and Vue on 30A.',
  address: 'Dune Allen',
  addressSub: '30A, Florida Panhandle',
  propertyMeta: '4 bedrooms · 2 bathrooms · Beach access steps away · Pet friendly',
};

export const signatureFeatures: SignatureFeature[] = [
  {
    title: 'Steps to the Beach',
    body: 'Beach access is just steps away from the backyard, making it easy to move between the cottage, outdoor living space, and sugar-white sand.',
    image: 'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-2.jpg',
    imageAlt: 'Sunset Bungalow beach access',
    tag: 'Beach access',
  },
  {
    title: 'Gulf Views',
    body: 'The home offers fabulous views of the Gulf of Mexico from inside and outside, including the primary suite and outdoor living space.',
    image: 'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-27.jpg',
    imageAlt: 'Sunset Bungalow Gulf views',
    tag: 'Gulf views',
  },
  {
    title: 'Outdoor Living Space',
    body: 'The outdoor living area includes beach views, lounge chairs, a gas grill, and a relaxed front porch overlooking Allen Lake.',
    image: 'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-33.jpg',
    imageAlt: 'Sunset Bungalow outdoor living',
    tag: 'Outside on 30A',
  },
  {
    title: 'Four Bikes Included',
    body: 'Four bikes are included so guests can enjoy the rhythm of 30A and explore the Dune Allen area.',
    image: 'https://inspirevp.com/wp-content/uploads/2022/11/sunset-bungalow-5.jpg',
    imageAlt: 'Sunset Bungalow bikes',
    tag: '4 bikes',
  },
];

export const essentialInfoGroups: EssentialInfoGroup[] = [
  {
    heading: 'At a glance',
    items: [
      '4 bedrooms',
      '2 bathrooms',
      'Sleeps up to 10 guests',
      'Beach access just steps away from the backyard',
      'Fabulous Gulf views',
      'Pet friendly with additional fee',
    ],
  },
  {
    heading: 'Key features',
    items: [
      'Expansive outdoor living space',
      'Front porch overlooking Allen Lake',
      'Gas grill',
      '4 bikes included',
      'Wi-Fi',
      'Washer and dryer',
      'Cable/Smart television',
      'Parking available on-site for up to 4 vehicles',
    ],
  },
  {
    heading: 'The kitchen',
    items: [
      "Chef's kitchen",
      'Top-of-the-line appliances',
      'Equipment and utensils provided',
      'Dining area seats 8',
    ],
  },
  {
    heading: 'The bedrooms',
    items: [
      'Primary suite: king bed, 55-inch flat-screen TV, outdoor access, Gulf views',
      'Primary bathroom: walk-in shower and double vanity',
      'Bedroom 2: queen bed and 40-inch television',
      'Bedroom 3: queen bed and 40-inch television',
      'Bedroom 4: twin bunk bed and 32-inch flat-screen television',
      'Guest bedrooms share the second full bathroom with shower/tub combination',
    ],
  },
  {
    heading: 'The area',
    items: [
      'Located in Dune Allen on 30A',
      'Across the street from Stinky’s Fish Camp',
      '1.5 miles from Shunk Gulley',
      '1.5 miles from Perfect Pig',
      '1.5 miles from Vue on 30A',
    ],
  },
];

export const reviews: PropertyReview[] = [];

export const conciergeConfig: PropertyConciergeConfig = {
  propertyId: 'sunset-bungalow-30a',
  propertyName: 'Sunset Bungalow on 30A',
  introText:
    'Hello — I’m here to help you get to know Sunset Bungalow on 30A. Ask about beach access, Gulf views, bikes, the sleeping layout, or whether it fits your trip.',
  seedQuestion: 'How close is the beach?',
  starters: [
    'How close is the beach?',
    'How many guests does it sleep?',
    'Does it allow pets?',
    'Are bikes included?',
    'Tell me about the outdoor space.',
    'What is nearby?',
  ],
};

export const inquiryData: PropertyInquiryData = {
  propertyName: 'Sunset Bungalow on 30A',
  propertyLocation: 'Dune Allen / 30A',
  sleeps: '10',
};

export const stickyBarData: StickyBookBarData = {
  propertyId: 'sunset-bungalow-30a',
  propertyName: 'Sunset Bungalow on 30A',
  location: 'Dune Allen · 30A',
  bedrooms: '4 bed',
  sleeps: 'Sleeps 10',
};
